import React from 'react';
import './AboutUs.css';

import { Banner, PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Process, Partners, TaxiSlider, DownloadApp } from '../../../sections';



const AboutUs = () => {
  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About /> {/* About section */}
        <Counter /> {/* Counter section */}
        <Services /> {/* Services section */}
        <WhyUs /> {/* Why Us section */}
        <Process /> {/* Process section */}
        <Banner /> {/* Banner Component */}
        <TaxiSlider /> {/* Taxi Slider section */}
        <Testimonials /> {/* Testimonials section */}
        <Team /> {/* Team section */}
        <DownloadApp /> {/* Download App section */}
        <Partners /> {/* Partners Section */}

      </section>

    </>
  );
}

export default AboutUs;